import axios from 'axios'

export default function catchError(error: any) {
	if (axios.isAxiosError(error)) console.log(error.message)
	else console.log(error.message)
}
